import { proxy } from 'valtio';
export interface PrivateModeState {
  /**
   * Whether or not a private session is currently active.
   */
  get enabled(): boolean;
}

export interface PrivateModeStateInternal extends PrivateModeState {
  enabled: boolean;
}

/**
 * Internal state for private mode.
 *
 * @deprecated Use {@link currentPrivateModeState} instead. This should only be used
 * internally by the private mode module.
 */
export const currentPrivateModeStateInternal: PrivateModeStateInternal = proxy({
  enabled: false,
});

/**
 * The current state of private mode in the document.
 */
export const currentPrivateModeState: PrivateModeState = currentPrivateModeStateInternal;

export const resetPrivateModeState = () => {
  currentPrivateModeStateInternal.enabled = false;
};
